var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "last_version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_DETALLE_CAMPA\\xD1A",
    transform: "translate(-40.000000, -287.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9 L4.12419917,1.07658546 C4.46855644,0.415006016 5.15242925,0 5.89826388,0 L18.2609899,0 C19.0062725,0 19.6897348,0.414397872 20.0343449,1.07522311 L24.1669922,9 L24.8371073,17.8489765 C24.9205153,18.9503923 24.0952569,19.9108818 22.9938411,19.9942898 C22.9435898,19.9980952 22.8932126,20 22.8428175,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,9 Z M2,9.48934749 L2,18 L22.8428175,18 L22.2037178,9.56058669 L18.2609899,2 L5.89826388,2 L2,9.48934749 Z",
    id: "Rectangle",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375,10 L15.7083333,10 C14.9791667,12.0833333 13.625,13.125 11.5416667,13.125 C9.45833333,13.125 8.10416667,12.0833333 7.375,10 L1.64583333,10",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2.08333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTasks);
export default __webpack_public_path__ + "static/media/myTasks.c4f958fc44d6389afa5f5938a0ac8a87.svg";
export { ForwardRef as ReactComponent };